import { createAction, props } from '@ngrx/store';
import {
  IRemoveEmployeeRequest,
  IRemoveEmployeeResponse,
  ICheckUserRemovedRequest,
  ICheckUserRemovedResponse
} from '../models/remove-user.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';

//Remove a user from business
export const loadRemoveUserRequest = createAction('[RemoveUser] Load RemoveUser request', props<{ request: IRemoveEmployeeRequest }>());

export const loadRemoveUserSuccess = createAction('[RemoveUser] Load RemoveUser Success', props<{ response: IRemoveEmployeeResponse }>());

export const loadRemoveUserFailure = createAction('[RemoveUser] Load RemoveUser Failure', props<{ error: IGenericError<ErrorResponse> }>());

//Check if user has been removed
export const checkIfUserRemovedRequest = createAction(
  '[RemoveUser] check user is removed request',
  props<{ request: ICheckUserRemovedRequest }>()
);

export const checkIfUserRemovedSuccess = createAction(
  '[RemoveUser] check user is removed Success',
  props<{ response: ICheckUserRemovedResponse }>()
);

export const checkIfUserRemovedFailure = createAction(
  '[RemoveUser] check user is removed Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
